// Route ordinary product forms through the real Shopify Ajax cart.
// Payment gateways and other site forms retain their standard Shopify behavior.
(()=>{
 document.addEventListener('submit',e=>{
  const form=e.target;if(!(form instanceof HTMLFormElement)||form.id==='v3-purchase-form')return;
  if(!/\/cart\/add$/.test(new URL(form.action,location.href).pathname))return;
  if(!window.velumaCartReady)return;
  e.preventDefault();e.stopImmediatePropagation();
  window.dispatchEvent(new CustomEvent('veluma-preview-add',{detail:{...Object.fromEntries(new FormData(form)),choosePackSize:!!form.closest('product-card')||(form.getAttribute('id')||'').startsWith('complementary-product-')}}));
 },true);
})();
